import { render, staticRenderFns } from "./vdoDetail.vue?vue&type=template&id=1ea26666&scoped=true&"
import script from "./vdoDetail.vue?vue&type=script&lang=js&"
export * from "./vdoDetail.vue?vue&type=script&lang=js&"
import style0 from "./vdoDetail.vue?vue&type=style&index=0&id=1ea26666&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./vdoDetail.vue?vue&type=style&index=1&id=1ea26666&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea26666",
  null
  
)

export default component.exports